import { render } from "./Navbar.vue?vue&type=template&id=6db60cec&scoped=true"
import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=6db60cec&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db60cec"],['__file',"resources/js/frontend/components/Navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6db60cec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6db60cec', __exports__)) {
    console.log('reload')
    api.reload('6db60cec', __exports__)
  }
  
  module.hot.accept("./Navbar.vue?vue&type=template&id=6db60cec&scoped=true", () => {
    console.log('re-render')
    api.rerender('6db60cec', render)
  })

}


export default __exports__